// Port of api/fuel/app/classes/filter/search/games/filters/post/play/last.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import Helpers from 'offline/filter/core/helpers'

export default {
	name: 'post.play.last',
	priority: 55,
	post: true,
	require: function(config, filter) {
		return config.ownerType === F.OWNER_USER && filter.play && filter.play.last
	},
	run: function(config, filter, data, results) {
		var to = filter.played && filter.played.sometime ? filter.played.sometime.to : 0
		if (config.resultType === F.RESULT_GAME) {
			if (!to || !results.index.length) return results
			var excludeGameRows = DB.query('SELECT DISTINCT game_id FROM play WHERE play_date > ' + to + ' AND game_id IN(' + Util.in(results.index) + ') AND user_id IN(' + Util.in(data.users) + ')')
			var excludeGameIds = Util.pluck(excludeGameRows, 'game_id')
			var newIndex = results.index.filter(function(id) { return excludeGameIds.indexOf(id) === -1 })
			results.index = Helpers.preserve_sort(results.index, newIndex.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
			return results
		}

		if (!results.games || !results.games.length) return results

		var newGames = results.games.slice()
		if (to) {
			var excludeRows = DB.query('SELECT DISTINCT game_id FROM play WHERE play_date > ' + to + ' AND game_id IN(' + Util.in(results.games) + ') AND user_id IN(' + Util.in(data.users) + ')')
			var excludeIds = Util.pluck(excludeRows, 'game_id')
			newGames = results.games.filter(function(gameId) {
				return excludeIds.indexOf(gameId) === -1
			})
			results.index = results.index.filter(function(id) {
				var gid = results.mapIndex ? results.mapIndex[id] : id
				return excludeIds.indexOf(gid) === -1
			})
			results.games = Helpers.preserve_sort(results.games, newGames.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		}

		if (newGames.length) {
			var sql = 'SELECT game_id, play_id, play_date FROM play WHERE game_id IN(' + Util.in(newGames) + ') AND user_id IN(' + Util.in(data.users) + ')'
			if (to) sql += ' AND play_date <= ' + to
			sql += ' ORDER BY game_id ASC, play_date DESC, play_id DESC'
			var playRows = DB.query(sql)
			var lastPlayByGame = {}
			for (var i = 0; i < playRows.length; i++) {
				if (lastPlayByGame[playRows[i].game_id] === undefined) {
					lastPlayByGame[playRows[i].game_id] = parseInt(playRows[i].play_id, 10)
				}
			}
			results.index = results.index.filter(function(id) {
				var gid = results.mapIndex ? results.mapIndex[id] : id
				return lastPlayByGame[gid] === id
			})
		}

		return results
	}
}
